import { useQuery } from "@tanstack/react-query";

import { getRiskConfig } from "@/api/risk";
import { RiskQueryKeys } from "./riskQueryKeys";

// The viewer's OWN risk config (threshold + enabled).
export const useRiskConfig = () => {
  return useQuery({
    queryKey: [RiskQueryKeys.Config],
    queryFn: ({ signal }) => getRiskConfig({ signal }),
  });
};
